module.exports = __webpack_public_path__ + "img/01-app-search.1d58d297.png";